'use strict';

const _=require('pulsar-utils/dist-es6/_');
const IncidentBucketTypes=require('../../../../../../dist-es6/client/features/fleetInsight/components/fleetIncidents/incidentBucketTypes');
const ItemPickerDirective=require('../../../../../../dist-es6/client/directives/itemPickerDirective/itemPickerDirective');
const ItemPickerDirectiveController=ItemPickerDirective.DirectiveController;let

IncidentBucketTypePickerDirective=class IncidentBucketTypePickerDirective extends ItemPickerDirective{
get templateUrl(){return'/templates/features/fleetInsight/components/fleetIncidents/incidentBucketTypePickerTemplate'}
get controller(){return IncidentBucketTypePickerDirectiveController}};let


IncidentBucketTypePickerDirectiveController=class IncidentBucketTypePickerDirectiveController extends ItemPickerDirectiveController{
static get $inject(){return['$scope','$timeout','displaySettingsService']}

constructor($scope,$timeout,displaySettingsService){
super($scope);

this._displaySettingsService=displaySettingsService;

const use24HourTimeline=_.get(this,'_displaySettingsService.use24HourTimeline',!1);
this.items=IncidentBucketTypes.getBucketTypes({use24HourTimeline});

this.itemFormatter=type=>type.label;
this._reevaluateSelection=()=>this._reevaluateSelectionAndUpdateDisplaySettings();

const label=this._displaySettingsService.stickySettings.get('selectedIncidentBucketTypeLabel');
const stickyItem=_.find(this.items,{label});
if(_.exists(stickyItem)){
this.selectedItem=stickyItem;
}

this._reevaluateSelection();
}

_reevaluateSelectionAndUpdateDisplaySettings(){
super._reevaluateSelection();
this._displaySettingsService.stickySettings.set('selectedIncidentBucketTypeLabel',this.selectedItem.label);
}};



module.exports=IncidentBucketTypePickerDirective;
//# sourceMappingURL=incidentBucketTypePickerDirective.js.map
